<template>
  <div class="player__cdn">
    <video-player
      v-if="this.PlayerReady"
      :autoplay="this.autoplay"
      :options="videoOptions"
      :panorama="panorama"
      :rightClick="handleContextMenu"
      :leftClick="handleLeftClick"
      :showSettingsModal="handleShowSettingsModal"
      :setPlayer="setPlayer"
      :videoData="videoData"
    />
    <right-click-menu
      v-if="showContextMenu"
      :contextMenuPos="contextMenuPos"
      :showStatsModal="handleShowStatsModal"
      :playerLoop="setPlayerLoop"
      :isRepeat="isRepeat"
    />
    <StatsModal
      v-if="showStatsModal"
      :closeStatsModal="handlCloseStatsModal"
      :player="player"
      :videoData="videoData"
    />
    <SettingsModal
      v-if="showSettingsModal"
      :closeSettingsModal="handlCloseSettingsModal"
      :player="mainPlayer"
      :videoRef="player"
      :currentQualityIndex="currentQualityIndexUpdate"
      :currentRateIndex="currentRateIndexUpdate"
    />
    <google-analytics />
  </div>
</template>
<script>
import VideoPlayer from "@/components/VideoPlayer.vue";
import RightClickMenu from "./components/parts/RightClickMenu/RightClickMenu.vue";
import StatsModal from "./components/parts/StatsModal/StatsModal.vue";
import SettingsModal from "./components/parts/SettingsModal/SettingsModal.vue";
import axios from "axios";
export default {
  name: "emp-player",
  components: {
    VideoPlayer,
    RightClickMenu,
    StatsModal,
    SettingsModal,
  },
  props: [
    "standalone",
    "query",
    "url",
    "fileName",
    "autoplay",
    "loop",
    "controls",
    "src",
    "refPlayer",
  ],
  data() {
    return {
      loaded: false,
      parsedStandalone: null,
      parsedQuery: null,
      parsedUrl: null,
      videoFileName: null,
      player: {},
      mainPlayer: {},
      playerCSS: false,
      count: 0,
      options: {},
      playerHost: "",
      ApiHost: "",
      ApiToken: "",
      PlayerReady: false,
      panorama: false,
      showContextMenu: false,
      showStatsModal: false,
      showSettingsModal: false,
      isRepeat: false,
      currentQualityIndex: -1,
      currentQualityIndexUpdate: (i) => {
        if (i) {
          this.currentQualityIndex = i;
        }
        return this.currentQualityIndex;
      },
      currentRateIndex: 3,
      currentRateIndexUpdate: (i) => {
        if (i) {
          this.currentRateIndex = i;
        }
        return this.currentRateIndex;
      },
      setPlayer: (p, mainPlayer) => {
        this.player = p;
        this.mainPlayer = mainPlayer;
      },
      contextMenuPos: {
        xPos: 0,
        yPos: 0,
      },
      handleShowSettingsModal: () => {
        this.showSettingsModal = true;
        this.handleLeftClick();
      },
      handlCloseSettingsModal: () => {
        this.showSettingsModal = false;
      },
      handleShowStatsModal: () => {
        this.showStatsModal = true;
        this.handleLeftClick();
      },
      handlCloseStatsModal: () => {
        this.showStatsModal = false;
      },
      handleLeftClick: () => {
        if (this.showContextMenu) this.showContextMenu = false;
      },
      handleContextMenu: (e) => {
        e.preventDefault();
        this.showContextMenu = true;
        this.contextMenuPos.xPos = e.clientX;
        this.contextMenuPos.yPos = e.clientY;
      },
      setPlayerLoop: () => {
        this.isRepeat = !this.isRepeat;
        this.player.loop = this.isRepeat;
        this.handleLeftClick();
      },
      baseURL: "https://api-k8s-parcoursmetiers.webtv-solution.com",
      cryptext: "hpNmy1WpnBVBmsOf3UNkQpNqC0iDwS0lDp55v1VWhJoZSGK6L88GgxONmb6CkhPUmGyZCM9eXQgtubYsBYrqDg",
      videoData: {},
      videoOptions: {
        autoplay: true,
        controls: true,
        sources: [
          {
            src: "",
            type: "",
          },
        ],
      },
    };
  },
  mounted() {
    this.initData();
    /**
     * GOOGLE ANALYTICS
     */
    window.dataLayer = window.dataLayer || [];
    this.gtag("js", new Date());
    this.gtag("config", "UA-106409419-2", { anonymize_ip: true });
  },
  methods: {
    async initData() {
      let src = this.src;
      if (!src) {
        src = "prn44_jf19_1442";
      }
      if (src) {
        /*var env_data = await axios.get("https://fo-player-k8s-parcoursmetiers.webtv-solution.com/env-file-config.json")
        env_data = env_data.data;*/
        let resp = await axios.get(
          `https://parcoursmetiers-tv-api.webtv-solution.com/video/video/decrypt/infos?uid=${src}`,
          {
            headers: {
              Authorization:
                "Bearer eyJhbGciOiJSUzI1NiJ9.eyJ1c2VybmFtZSI6ImVtcGFkbWluIiwiaWQiOjEsInJvbGVzIjpbIlJPTEVfU1VQRVJfQURNSU4iLCJST0xFX1VTRVIiXSwiaWF0IjoxNTgzMjM0MzUyLCJleHAiOjc4OTA0MzQzNTJ9.gLY7-MEtQ4w4zLdGzXRXDhC8UBTYUDWOy5x3ArW9X8RsuQlSM4F6A0AzpAYm4x8bA57d-KkMOOK4ToJXuCtnUHaEQQyujKkPBF2bRFI_mXKkPKvDF3nTL5nVDSZc4Jous1m369yWmMqFoYlLi_lo46GrweCDyHURfdpIBpJXrXmUT2hC8-tpx7g1vvR6ZIV2MM5V9Oit_3F8-nE05q9y8d4xSKFaemK6-f5HRATB8fdS0paA6GNmLg7U-XNwCIvh9sUHku2zdmQiyq9m5K0b4xkQCRRDEyfnvDZ3hF7ojQv4-SGmGAmMhNhUXiPjJ7A2gfmQUeBR9BQlhbDKm-dGf0Ggux-sdFGZlqKpUvaoKb5ctJGufeINnWcHzqx2CTz1JcQSBh3yvGtEWaLLAo29XDFLrpCyis_8O3jEsLee35BUzqVoJiDJ6y-p8YARUopo3F7CrK6Cjd1cng4oNUk2ocIE4Qq2EWvfKg2ELb6GwMVJPBeyOOuSMDNY3LsX6H11VxH2Wkwdu7lFW3BaXV_MvIzLY90yEl6v4_pbyAEoy_MKgnpqT-jVSeWsJGPybJxmQQtuSnXkLXFcGm1ZAbmD0n0ulX1LwcvLKkiOiAesy19rx26xzmDLbFIzAWIOWElBgybU0zUs42Wmu-013j48coP-hgAleHtNbNw2vub4InU",
            },
          }
        );
        // this.cryptext = resp.data?.dataVideo.crypted;
        this.videoOptions = resp.data?.data.playerOptions;
        this.videoOptions["hls"] = { withCredentials: true };
        this.videoData = resp.data?.data;
        this.panorama = resp.data?.data.panoramaOptions;
        this.PlayerReady = true;
      } else {
        this.playerHost = "/404";
      }
    },
    gtag() {
      // eslint-disable-next-line
      dataLayer.push(arguments);
    },
    play() {
      this.mainPlayer.play();
    },
    pause() {
      this.mainPlayer.pause();
    },
  },
};
</script>
<style>
@import "https://vjs.zencdn.net/7.20.2/video-js.css";

body {
  margin: 0px;
  overflow: hidden;
}

.player__cdn {
  --vm-theme-color: #e64444;
  --vm-dropdown-bg: #e9e9e9;
  --vm-dropdown-btn-color: #999;
  --vm-dropdown-btn-active-arrow-color: #5e5e5e;
  --vm-hr: #999;
  --vm-video-preview-border: 2px solid #bdbdbd;
  --vm-video-preview-duration-bg: 94, 94, 94;
  --vm-video-preview-duration-color: #fff;
  --vm-card-bg: 242, 242, 242;
  --vm-border-color: #999;
  --vm-modal-close-btn-bg: #fff;
  --vm-modal-background: #e9e9e9;
  --vm-modal-close-icon-color: #999;
  --vm-modal-font-color: #5e5e5e;
  --vm-modal-section-btn-color: #313131;
  --vm-slider-thumb-bg: #000;
  --vm-slider-track-height: 8px;
  --vm-slider-track-focused-height: 10px;
  --vm-slider-track-color: hsla(0, 0%, 100%, 0.5);
  --vm-controls-bg-vars: 210, 210, 210;
  --vm-controls-border-radius: 0px;
  --vm-control-border-radius: 0px;
  --vm-control-icon-size: 26px;
  --vm-control-focus-color: #000;
  --vm-scrubber-loading-stripe-size: 100px;
  --vm-scrubber-buffered-bg: #000;
  --vm-time-font-weight: 600;
  --vm-video-icons-border: 2px solid #999;
  --vm-video-input-font-color: #999;
  --vm-video-time-counter-font-color: #cfcfcf;
  --vm-video-textarea-resizer: #d2d2d2;
  --vm-shortcut-front-color: #d2d2d2;
  --vm-chapters-background-color: hsla(0, 0%, 94.9%, 0.52);
  --vm-chapters-scrollbar-color: #999;
  --vm-chapters-scrollbar-background: #e9e9e9;
  --vm-current-chapters-background-color: #f2f2f2;
  --vm-color-picker-border-color: #999;
  --vm-model-label-font-color: #787878;
  --vm-modal-stats-border: 1px solid #a9a9a9;
  --vm-spinner-fill-color: var(--vm-theme-color);
  overflow: hidden;
}

video::-webkit-media-controls {
  color: transparent;
  opacity: 0.0001;
  background: transparent;
}

video::cue {
  display: none;
  opacity: 0;
}

.container {
  padding: 0;
}

a,
.pointer {
  cursor: pointer;
}

.btn_link {
  background-color: rgba(0, 0, 0, 0);
  border-color: rgba(0, 0, 0, 0);
  border-style: none;
  cursor: pointer;
}

.modal_container {
  margin: 30px auto;
  width: 600px;
}

.modal_container_subtitle {
  margin: 10px auto;
  width: 600px;
  border-bottom: 1px solid RGBA(0, 0, 0, 0.06);
  padding-bottom: 1em;
}

.d_flex {
  display: flex;
}

.d_none {
  display: none !important;
}

.card {
  padding: 2px 10px;
  background: rgba(var(--vm-card-bg), 0.52);
  border: 1px solid var(--vm-border-color);
}

.card.padd_child_10 > div > div {
  padding-top: 10px;
  padding-bottom: 10px;
}

.card .card_btn {
  font-size: 13px;
  color: #5e5e5e;
  border: unset;
  background: unset;
  height: 24px;
  width: 55px;
}

.card .card_btn:hover,
.card .card_btn.active {
  background: var(--vm-shortcut-front-color);
  font-weight: 600;
  font-size: 13px;
  color: var(--vm-theme-color);
}

hr {
  border: solid var(--vm-hr);
}

.transition-max-height {
  transition: max-height 0.3s cubic-bezier(0.075, 0.82, 0.165, 1);
  overflow: hidden;
}

.transition-opacity {
  transition: opacity 0.3s cubic-bezier(0.95, 0.05, 0.795, 0.035);
}

.duration-300 {
  transition-duration: 300ms;
}

.duration-500 {
  transition-duration: 500ms;
}

.opacity-0 {
  opacity: 0;
}

.opacity-100 {
  opacity: 1;
}

.scale-0 {
  max-height: 0;
}

.my-10 {
  margin-top: 10px;
  margin-bottom: 10px;
}

audio.sc-vm-file,
video.sc-vm-file {
  border-radius: inherit;
  vertical-align: middle;
  width: 100%;
  outline: 0;
}

.video_container:not(.with_slides) .sc-vm-file {
  position: absolute;
  top: 0;
  left: 0;
  border: 0;
  height: 100%;
  user-select: none;
}

.custom-scroll ::-webkit-scrollbar {
  width: 6px;
  height: 0px;
}

.custom-scroll ::-webkit-scrollbar-track {
  background: var(--vm-chapters-scrollbar-background);
}

.custom-scroll ::-webkit-scrollbar-thumb {
  background: var(--vm-chapters-scrollbar-color);
}

.custom-scroll ::-webkit-scrollbar-thumb:hover {
  background: var(--vm-modal-section-btn-color);
}

body {
  margin: 0;
  font-family: "Open Sans";
}

.volumeControl {
  margin-top: 0.5em;
}

@media screen and (max-width: 576px) {
  .modal_container {
    margin-top: 0px;
    width: 100%;
  }

  html {
    overflow: hidden;
  }

  .smallCard {
    width: calc(100% - 80px);
  }
}

@media screen and (max-width: 768px) {
  .modal_container {
    margin-top: 20px;
    width: 80%;
  }

  .card {
    width: 100%;
  }

  .smallCard {
    width: 100%;
  }
}

@media screen and (max-height: 576px) {
  .modal_container {
    margin-top: -60px;
    width: 70%;
  }
}

@media screen and (max-width: 576px) {
  .card .card_btn {
    font-size: 9px;
    width: 35px;
  }

  .card .card_btn:hover,
  .card .card_btn.active {
    font-size: 9px;
  }
}

.SubtitleAccItem {
  border: 1px solid rgba(0, 0, 0, 0.5);
}

.liveIndicator .hidden {
  display: flex !important;
}

.liveIndicator {
  display: flex !important;
}

.hidden {
  display: flex !important;
}

.captions {
  transform: translateY(calc(var(--vm-controls-height) * 1));
}

.videojs-panorama-player-dimensions.vjs-fluid {
  padding: 0 !important;
}

.vjs-fade-out {
  display: block;
  visibility: hidden;
  opacity: 0;
  -webkit-transition: visibility 1.5s, opacity 1.5s;
  -moz-transition: visibility 1.5s, opacity 1.5s;
  -ms-transition: visibility 1.5s, opacity 1.5s;
  -o-transition: visibility 1.5s, opacity 1.5s;
  transition: visibility 1.5s, opacity 1.5s;
  /* Wait a moment before fading out the control bar */
  -webkit-transition-delay: 2s;
  -moz-transition-delay: 2s;
  -ms-transition-delay: 2s;
  -o-transition-delay: 2s;
  transition-delay: 2s;
}

.vjs-has-started.vjs-user-inactive.vjs-playing:hover .vjs-control-bar {
  opacity: 1 !important;
  cursor: pointer;
}

.video-js .vjs-big-vr-play-button {
  content: "";
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='white' viewBox='0 0 24 24'%3E%3Cpath d='M7.00002 5.47025C7.00002 5.09676 7.57955 4.87281 7.87872 5.07784L17.7971 12.1762C18.0676 12.3616 18.0676 12.7756 17.7971 12.961L7.8787 19.9222C7.57953 20.1272 7 19.9032 7 19.5297L7.00002 12.5686V5.47025Z'/%3E%3C/svg%3E") !important;
  background-repeat: no-repeat !important;
  background-size: contain !important;
  background-position: 55% calc(50% - 0px) !important;
}

.video-js .vjs-control-bar {
  background-color: var(--vm-modal-background) !important;
  font-family: var(--vm-player-font-family);
  display: flex !important;
  color: var(--vm-control-focus-color);
}

.video-js .vjs-volume-level {
  background-color: var(--vm-control-focus-color) !important;
}

.video-js .vjs-custom-control-spacer {
  display: block !important;
}

.vjs-playback-rate .vjs-playback-rate-value {
  display: none;
}

.vjs-playback-rate
  .vjs-menu-button
  .vjs-menu-button-popup
  .vjs-control
  .vjs-button {
  display: none !important;
}

.video-js canvas {
  cursor: grabbing !important;
}

.ContainerIframe {
  background-color: grey;
  text-align: center;
  height: 100vh;
}

.ContainerIframe .PlayerIframe {
  width: calc(100% - 5vw);
  margin: auto;
}

.ContainerIframe .IframeStyle {
  aspect-ratio: 16/7.5;
}

.Loading {
  visibility: hidden;
}

.NotLoading {
  visibility: visible;
}

.PlaylistHidden {
  display: grid;
  grid-template-columns: 3fr 0.5fr;
}

.PlaylistVisible {
  gap: 10px;
}

.video-js .vjs-time-control {
  display: block;
  padding-right: 0rem !important;
  padding-left: 0rem !important;
  min-width: 0 !important;
  line-height: 3.3em !important;
}

.video-js .vjs-current-time,
.vjs-no-flex .vjs-current-time {
  display: block !important;
  padding-right: 0.5rem !important;
}

.video-js .vjs-duration,
.vjs-no-flex .vjs-duration {
  display: block !important;
  padding-left: 0.3rem !important;
}

.video-js .vjs-remaining-time {
  display: none;
}

.video-js .vjs-play-progress:before {
  top: -0.25em !important;
}

.video-js .vjs-icon-placeholder:before {
  top: 0.12em !important;
  font-size: 1.7em !important;
}
</style>